import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/fillList_action";
import Header from "../../../common_components/Header";
import { ToastContainer, toast } from "react-toastify";
import {
  thirdParty_detail_action,
  insertUpdate_thirdParty_vendorOrderDtl_action,
  thirdParty_VendorOrder_detail_action,
} from "../../../actions/accounts_action/account_third_party_orders_action";
import { Button, Modal } from "react-bootstrap";
import moment from "moment";
import Resizer from "react-image-file-resizer";
import {
  accountTypeActionId,
  BASE_URL,
  sessionExpireMessage,
  tokenInavlidMessage,
} from "../../../utils/constants";
import SignatureCanvas from "react-signature-canvas";
import { client_detail_action } from "../../../actions/master_actions/client_action";
import {
  chat_detail_action,
  insert_chat_action,
} from "../../../actions/myOrders_action/chat_action";
const floatingLabelCSSOrders = `
.floating-label-outside{
  top:-7px !important;
  font-size:10px !important;
  background:#fff !important;
}
.mendatory_class{
  font-size:12px;
}
`;
class ThirdPartyOrderAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showDetails: false,
      isAccordionExpanded: false, isChatLoading: false,
      showAdditionalDetails: false,
      showPackageDetails: "",
      showAdditionalReq: "",
      isAdmin: false,
      OrderNo: "",
      OrderID: "",
      OrderDtlID: "",
      ServiceID: "",
      VendorID: "",
      VendorServicesPackageID: "",
      VendorOrderDtlID: "",
      OrderDate: "",
      Venue: "",
      Service: "",
      VendorCompany: "",
      Action: "",
      BookingDate: "",
      BookingSlot: "",
      thirdPartyDetails: [],
      bookingDetails: [],
      orderDetails: [],
      packageList: [],
      Package: "",
      FinalAmount: "",
      AdditionalAmount: "",
      IsOrderAcceptedbyVendor: false,
      IsOrderAcceptedbyClient: false,
      IsQuotationSubmitted: false,
      IsQuotationApproved: false,
      IsInvoiceSubmitted: false,
      IsPaymentReceived: false,
      IsFinalInvoiceSubmitted: false,
      FinalPaymentReceived: false,
      //all uploads
      selectedFile: null,
      downloadUrl: "",
      //quotation
      quotationFormFile: "",
      quotationFileName: "",
      quotationFileType: "",
      quotationFilePath: "",
      //finalAmount
      invoiceFormFile: "",
      invoiceFileName: "",
      invoiceFileType: "",
      invoiceFilePath: "",

      receiptFormFile: "",
      receiptFileName: "",
      receiptFileType: "",
      receiptFilePath: "",
      //additionalReqUpload
      additionalInvoiceFormFile: "",
      additionalInvoiceFileName: "",
      additionalInvoiceFileType: "",
      additionalInvoiceFilePath: "",

      additionalReceiptFormFile: "",
      additionalReceiptFileName: "",
      additionalReceiptFileType: "",
      additionalReceiptFilePath: "",
      //mailFlag
      nodeMailFlag: "",
      // canvas
      OrderAcceptedbyClientSignature: "",
      clientAcceptSignatureFlag: false,
      isSignatureSaved: false,
      OrderAcceptedbyClientContact: "",
      OrderAcceptedbyClientSignatureBy: "",
      OrderAcceptedbyClientSignatureDate: "",
      //cleint details
      registrationNumber: "",
      PANCardNo: "",
      NameonPANCard: "",
      GSTNo: "",
      CompanyStatus: "",
      TANNumber: "",
      UINNumber: "",

      //chatbox
      isChatOpen: false,
      chat: "",
      chatHdr: [],
      chatDtl: [],
    };
    this.getVendorOrderDetails = this.getVendorOrderDetails.bind(this);
    this.getThirdPartyDetails = this.getThirdPartyDetails.bind(this);
  }

  componentDidMount() {
    console.log("log", this.props.location);
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    setTimeout(() => {
      const roleId = sessionStorage.getItem("roleId");
      console.log(roleId, "roleId");
      if (roleId === "13") {
        this.setState({ isAdmin: false });
      } else {
        this.setState({ isAdmin: true });
      }
    }, 30);
    const sortUrl = BASE_URL.split("/api");

    this.setState({ downloadUrl: sortUrl[0] });

    this.setState({
      OrderID:
        this.props.location.state != null &&
          this.props.location.state.OrderID != null
          ? this.props.location.state.OrderID
          : "",
      ServiceID:
        this.props.location.state != null &&
          this.props.location.state.ServiceID != null
          ? this.props.location.state.ServiceID
          : "",
      VendorID:
        this.props.location.state != null &&
          this.props.location.state.VendorID != null
          ? this.props.location.state.VendorID
          : "",
    });
    const OrderID =
      this.props.location.state != null &&
        this.props.location.state.OrderID != null
        ? this.props.location.state.OrderID
        : "";
    const ServiceID =
      this.props.location.state != null &&
        this.props.location.state.ServiceID != null
        ? this.props.location.state.ServiceID
        : "";
    const VendorID =
      this.props.location.state != null &&
        this.props.location.state.VendorID != null
        ? this.props.location.state.VendorID
        : "";
    this.getThirdPartyDetails(OrderID, ServiceID, VendorID);
    setTimeout(() => {
      this.getVendorOrderDetails(OrderID, ServiceID, VendorID);
    }, 200);

    // this.chatInterval = setInterval(this.getChatDetails, 5000);
    console.log(this.state.isAdmin);
  }
  componentWillUnmount() {
    // Clear interval to avoid memory leaks
    clearInterval(this.chatInterval);
  }

  getFillList(value, userID) {
    this.props
      .fill_action(value, userID == "" || userID == null ? null : userID)
      .then((data) => {
        if (data.error != 1) {
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getThirdPartyDetails(OrderID, ServiceID, VendorID) {
    this.setState({ isLoading: true });
    this.props
      .thirdParty_detail_action(OrderID, ServiceID, VendorID)
      .then((data) => {
        console.log("Vendor details--------", data);
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          const thirdPartyDetails = {
            OrderID: data.data[0][0]["OrderID"],
            OrderNo: data.data[0][0]["OrderNo"],
            OrderDtlID: data.data[0][0]["OrderDtlID"],
            ServiceID: data.data[0][0]["ServiceID"],
            OrderDate: data.data[0][0]["OrderDate"],
            ServiceName: data.data[0][0]["Service"],
            VendorCompany: data.data[0][0]["VendorCompany"],
            ClientID: data.data[0][0]["ClientID"],
            Venue: data.data[0][0]["Venue"],
            Action: data.data[0][0]["Action"],
            BookingDate: data.data[1][0]["BookingDate"],
            BookingSlot: data.data[1][0]["Time"],
            VendorServicesPackageID: data.data[2][0]["VendorServicesPackageID"],
            Package: data.data[2][0]["Package"],
            PackageDetails: data.data[2][0]["PackageDetails"],
            AdditionalServiceRequirement:
              data.data[2][0]["AdditionalServiceRequirement"],
            packageList: data.data[2],
          };
          const ClientID = data.data[0][0]["ClientID"];
          this.setState({
            thirdPartyDetails: thirdPartyDetails,
            OrderDtlID: data.data[0][0]["OrderDtlID"],
            VendorServicesPackageID: data.data[2][0]["VendorServicesPackageID"],
          });
          if (ClientID != null) {
            this.props
              .client_detail_action(ClientID)
              .then((data) => {
                console.log("Client details--------", data);
                if (data.error != 1) {
                  this.setState({
                    registrationNumber: data.data[0]["CompanyRegistrationNo"],
                    PANCardNo: data.data[0]["PanNo"],
                    NameonPANCard: data.data[0]["NameOnPanCard"],
                    GSTNo: data.data[0]["GSTNo"],
                    TANNumber: data.data[0]["TanNo"],
                    UINNumber: data.data[0]["UINNo"],
                    ClientID: data.data[0]["ClientID"],
                  });
                } else {
                  if (
                    data.msg == sessionExpireMessage ||
                    data.msg == tokenInavlidMessage
                  ) {
                    //after session expire.....................
                    sessionStorage.clear();
                    this.props.navigate("/normalView");
                    setTimeout(() => {
                      toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }, 500);
                  } else {
                    this.setState({ isLoading: false });
                    toast.error(data.data, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }

          console.log("thirdPartyDetails", thirdPartyDetails);
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  getVendorOrderDetails(OrderID, ServiceID, VendorID) {
    // this.setState({ isLoading: true });
    this.props
      .thirdParty_VendorOrder_detail_action(OrderID, ServiceID, VendorID)
      .then((data) => {
        console.log("Vendor Order details--------", data);
        if (data.error !== 1) {
          this.setState({ isLoading: false });

          this.setState({
            ClientName: data.VendorOrderDtl.ClientName,
            ClientEmail: data.VendorOrderDtl.ClientEmail,
            VendorCompany: data.VendorOrderDtl.VendorCompany,
            VendorEmail: data.VendorOrderDtl.VendorEmail,
            VendorOrderDtlID: data.VendorOrderDtl.VendorOrderDtlID,
            OrderID: data.VendorOrderDtl.OrderID,
            ServiceID: data.VendorOrderDtl.ServiceID,
            ServiceName: data.VendorOrderDtl.ServiceName,
            IsOrderAcceptedbyVendor:
              data.VendorOrderDtl.IsOrderAcceptedbyVendor,
            quotationFilePath: data.VendorOrderDtl.quotationFilePath,
            IsQuotationSubmitted: data.VendorOrderDtl.IsQuotationSubmitted,
            IsQuotationApproved: data.VendorOrderDtl.IsQuotationApproved,
            FinalAmount: data.VendorOrderDtl.FinalAmount,
            invoiceFilePath: data.VendorOrderDtl.invoiceFilePath,
            IsInvoiceSubmitted: data.VendorOrderDtl.IsInvoiceSubmitted,
            IsFinalInvoiceSubmitted:
              data.VendorOrderDtl.IsFinalInvoiceSubmitted,
            IsPaymentReceived: data.VendorOrderDtl.IsPaymentReceived,
            receiptFilePath: data.VendorOrderDtl.receiptFilePath,
            AdditionalAmount: data.VendorOrderDtl.AdditionalAmount,
            IsOrderAcceptedbyClient:
              data.VendorOrderDtl.IsOrderAcceptedbyClient,
            additionalInvoiceFilePath:
              data.VendorOrderDtl.additionalInvoiceFilePath,
            additionalReceiptFilePath:
              data.VendorOrderDtl.additionalReceiptFilePath,
            OrderAcceptedbyClientContact:
              data.VendorOrderDtl.OrderAcceptedbyClientContact,
            OrderAcceptedbyClientSignature:
              data.VendorOrderDtl.OrderAcceptedbyClientSignature,
            OrderAcceptedbyClientSignatureBy:
              data.VendorOrderDtl.OrderAcceptedbyClientSignatureBy,
            OrderAcceptedbyClientSignatureDate:
              data.VendorOrderDtl.OrderAcceptedbyClientSignatureDate,
          });
          if (
            data.VendorOrderDtl["OrderAcceptedbyClientSignature"] != [] &&
            data.VendorOrderDtl["OrderAcceptedbyClientSignature"] != ""
          ) {
            const dataURL =
              "data:image/png;base64," +
              data.VendorOrderDtl["OrderAcceptedbyClientSignature"];
            console.log(dataURL, "signature");
            this.setState({ OrderAcceptedbyClientSignature: dataURL });
            this.setState({
              clientAcceptSignatureFlag: true,
              isSignatureSaved: true,
            });
          }
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  getChatDetails(OrderID, ServiceID, VendorID) {
    console.log("interval", VendorID, OrderID, ServiceID);
    //setting interval
    this.setState({ isChatLoading: true });
    setTimeout(() => {
      this.setState({ isChatLoading: false })
    }, 3000);
    this.chatInterval = setInterval(() => {
      this.props
        .chat_detail_action(OrderID, ServiceID, VendorID)
        .then((data) => {
          // Handle the response data

          if (data.error !== 1) {
            this.setState({
              chatHdr: data.chatHdr,
              chatDtl: data.chatDtl,
            });
            console.log("chat", data);
          } else {
            // Handle error messages
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toast.error(data.data, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }, 3000);
  }
  formatDate(orDate) {
    const options = { month: "long", day: "numeric", year: "numeric" };
    const date = new Date(orDate);
    return date.toLocaleDateString(undefined, options);
  }
  togglePackageDetailsModal(PackageDetails, Package) {
    this.setState((prevState) => ({
      showDetails: !prevState.showDetails,
      showPackageDetails: PackageDetails ? PackageDetails : "",
      Package: Package ? Package : "",
    }));
    console.log(PackageDetails, Package);
  }
  toggleAdditionalReqModal(AdditionalServiceRequirement, Package) {
    this.setState((prevState) => ({
      showAdditionalDetails: !prevState.showAdditionalDetails,
      showAdditionalReq: AdditionalServiceRequirement
        ? AdditionalServiceRequirement
        : "",
      Package: Package ? Package : "",
    }));
    console.log(AdditionalServiceRequirement, Package);
  }
  onFilePick = async (e, files, uploadNumber) => {
    console.log(files);
    e.preventDefault();
    const file = files[0]; // Assuming only one file is selected

    // Check file type
    if (file.type !== "application/pdf") {
      toast.error("Only PDF files are allowed.", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      return;
    }
    // Check file size
    if (file.size > 5 * 1024 * 1024) {
      toast.error("File size more than 5MB is not allowed.", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      return;
    }

    // Read the PDF file
    const pdfData = await this.onPdfSelect(file);
    console.log(uploadNumber, "uploadNumber");
    if (uploadNumber == 1) {
      this.setState({
        selectedFile: file,
        quotationFormFile: pdfData,
        quotationFileName: file.name,
        quotationFileType: "pdf",
      });
    } else if (uploadNumber == 2) {
      this.setState({
        selectedFile: file,
        invoiceFormFile: pdfData,
        invoiceFileName: file.name,
        invoiceFileType: "pdf",
      });
    } else if (uploadNumber == 3) {
      this.setState({
        selectedFile: file,
        receiptFormFile: pdfData,
        receiptFileName: file.name,
        receiptFileType: "pdf",
      });
    } else if (uploadNumber == 4) {
      this.setState({
        selectedFile: file,
        additionalInvoiceFormFile: pdfData,
        additionalInvoiceFileName: file.name,
        additionalInvoiceFileType: "pdf",
      });
    } else if (uploadNumber == 5) {
      this.setState({
        selectedFile: file,
        additionalReceiptFormFile: pdfData,
        additionalReceiptFileName: file.name,
        additionalReceiptFileType: "pdf",
      });
    }
  };

  onPdfSelect = (file) => {
    return new Promise((resolve) => {
      let base64;
      let fileReader = new FileReader();
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        resolve(base64);
      };
      fileReader.readAsDataURL(file);
    });
  };

  removeFile(num) {
    if (num == 1) {
      this.setState({
        selectedFile: null,
        quotationFileName: "",
        quotationFileType: "",
        quotationFormFile: "",
        IsQuotationSubmitted: false,
      });
    } else if (num == 2) {
      this.setState({
        selectedFile: null,
        invoiceFileName: "",
        invoiceFileType: "",
        invoiceFileType: "",
      });
    } else if (num == 3) {
      this.setState({
        selectedFile: null,
        receiptFormFile: "",
        receiptFileName: "",
        receiptFileType: "",
      });
    } else if (num == 4) {
      this.setState({
        selectedFile: null,
        additionalInvoiceFileName: "",
        additionalInvoiceFileType: "",
        additionalInvoiceFormFile: "",
      });
    } else if (num == 5) {
      this.setState({
        selectedFile: null,
        additionalReceiptFileName: "",
        additionalReceiptFileType: "",
        additionalReceiptFormFile: "",
      });
    }
  }
  signatureRef = React.createRef();
  clearSignature = () => {
    this.signatureRef.current.clear();
    this.setState({
      isSignatureSaved: false,
    });
  };
  clearSaveSignatureImg = () => {
    this.setState({
      OrderAcceptedbyClientSignature: "",
      isSignatureSaved: false,
      clientAcceptSignatureFlag: false,
    });
  };
  saveSignature = () => {
    const OrderAcceptedbyClientSignature =
      this.signatureRef.current.toDataURL();
    {
      console.log(
        "this.signatureRef.current.isEmpty()",
        OrderAcceptedbyClientSignature
      );
    }

    if (this.signatureRef.current.isEmpty() == false) {
      this.setState({
        OrderAcceptedbyClientSignature: OrderAcceptedbyClientSignature,
        isSignatureSaved: true,
        clientAcceptSignatureFlag: true,
      });
    } else {
      toast.error("Please fill signature!");
    }
  };
  submitVendorUploads(submitType) {
    const {
      OrderNo,
      ClientName,
      ClientEmail,
      VendorCompany,
      VendorEmail,
      BookingDate,
      VendorOrderDtlID,
      OrderDtlID,
      ServiceID,
      VendorServicesPackageID,
      FinalAmount,
      AdditionalAmount,
      quotationFilePath,
      quotationFileName,
      quotationFileType,
      quotationFormFile,
      invoiceFilePath,
      invoiceFileName,
      invoiceFileType,
      invoiceFormFile,
      receiptFilePath,
      receiptFileName,
      receiptFileType,
      receiptFormFile,
      additionalInvoiceFilePath,
      additionalInvoiceFileName,
      additionalInvoiceFileType,
      additionalInvoiceFormFile,
      additionalReceiptFilePath,
      additionalReceiptFileName,
      additionalReceiptFileType,
      additionalReceiptFormFile,
      OrderID,
      VendorID,
      IsPaymentReceived,
      IsQuotationApproved,
      FinalPaymentReceived,
      IsOrderAcceptedbyVendor,
      IsQuotationSubmitted,
      IsInvoiceSubmitted,
      IsOrderAcceptedbyClient,
      IsFinalInvoiceSubmitted,
      nodeMailFlag,
      OrderAcceptedbyClientSignature,
      OrderAcceptedbyClientContact, ServiceName
    } = this.state;

    this.setState({ isLoading: true });
    let NodeMailFlag = nodeMailFlag;
    let isPaymentReceived = IsPaymentReceived;
    let isQuotationApproved = IsQuotationApproved;
    let isFinalPaymentReceived = FinalPaymentReceived;
    let isFinalInvoiceSubmitted = IsFinalInvoiceSubmitted;
    let isQuotationSubmitted = IsQuotationSubmitted;
    let isInvoiceSubmitted = IsInvoiceSubmitted;
    let isOrderAcceptedbyClient = IsOrderAcceptedbyClient;
    let isOrderAcceptedbyVendor = IsOrderAcceptedbyVendor;

    console.log("submitType----", submitType);
    if (submitType == "approveOrder") {
      isOrderAcceptedbyVendor = true;
      NodeMailFlag = "approveOrder";
    } else if (submitType == "rejectOrder") {
      isOrderAcceptedbyVendor = false;
      NodeMailFlag = "rejectOrder";
    }

    if (submitType == "quotationSubmit") {
      if (quotationFileName !== null && quotationFileName !== "") {
        isQuotationSubmitted = true;
        NodeMailFlag = "quotationSubmit";
      }
    } else if (submitType == "invoiceSubmit") {
      if (FinalAmount == null) {
        toast.error("kindly fill final amount", {
          position: "top-center",
          autoClose: 5000,
        });
      } else {
        if (invoiceFileName !== null && invoiceFileName !== "") {
          console.log("yesss");
          isInvoiceSubmitted = true;
          NodeMailFlag = "invoiceSubmit";
        }
      }
    } else if (submitType == "receiptSubmit") {
      if (receiptFileName !== null && receiptFileName !== "") {
        isPaymentReceived = true;
        NodeMailFlag = "receiptSubmit";
      }
    } else if (submitType == "submitFinalAmount") {
      isOrderAcceptedbyClient = true;
      NodeMailFlag = "submitFinalAmount";
    } else if (submitType == "additionalInvoiceSubmit") {
      isFinalInvoiceSubmitted = true;
      NodeMailFlag = "additionalInvoiceSubmit";
    } else if (submitType == "additionalReceiptSubmit") {
      isFinalPaymentReceived = true;
      NodeMailFlag = "additionalReceiptSubmit";
    }

    this.props
      .insertUpdate_thirdParty_vendorOrderDtl_action(
        OrderNo,
        ClientName,
        ClientEmail,
        VendorCompany,
        VendorEmail,
        BookingDate,
        VendorOrderDtlID,
        OrderDtlID,
        ServiceID,
        VendorServicesPackageID,
        FinalAmount,
        AdditionalAmount,
        isOrderAcceptedbyVendor,
        isOrderAcceptedbyClient,
        isQuotationSubmitted,
        isQuotationApproved,
        isInvoiceSubmitted,
        isPaymentReceived,
        isFinalInvoiceSubmitted,
        isFinalPaymentReceived,
        quotationFilePath,
        quotationFileName,
        quotationFileType,
        quotationFormFile,
        invoiceFilePath,
        invoiceFileName,
        invoiceFileType,
        invoiceFormFile,
        receiptFilePath,
        receiptFileName,
        receiptFileType,
        receiptFormFile,
        additionalInvoiceFilePath,
        additionalInvoiceFileName,
        additionalInvoiceFileType,
        additionalInvoiceFormFile,
        additionalReceiptFilePath,
        additionalReceiptFileName,
        additionalReceiptFileType,
        additionalReceiptFormFile,
        OrderID,
        VendorID,
        NodeMailFlag,
        OrderAcceptedbyClientSignature,
        OrderAcceptedbyClientContact, ServiceName
      )
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toast.success("Submitted Successfully", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          window.location.reload();
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  showOrderAcceptedByVendor(IsOrderAcceptedbyVendor, isAdmin) {
    if (isAdmin) {
      if (IsOrderAcceptedbyVendor == true) {
        return (
          <>
            {" "}
            <a
              href="javascript:void(0);"
              className="btn btn-sm btn-outline-success my_custom_orderPage_btns"
            >
              Accepted
            </a>
          </>
        );
      } else {
        return (
          <>
            {" "}
            <a
              href="javascript:void(0);"
              className="btn btn-sm btn-outline-warning my_custom_orderPage_btns"
            >
              Pending
            </a>
          </>
        );
      }
    } else {
      if (IsOrderAcceptedbyVendor == true) {
        return (
          <>
            {" "}
            <a
              href="javascript:void(0);"
              className="btn btn-sm btn-outline-success my_custom_orderPage_btns"
            >
              Accepted
            </a>
          </>
        );
      } else {
        return (
          <>
            <a
              href="javascript:void(0);"
              className="btn btn-success my_custom_orderPage_btns btn-sm mr-2"
              onClick={() => {
                this.submitVendorUploads("approveOrder");
              }}
            >
              Accept
            </a>
            <a
              href="javascript:void(0);"
              className="btn btn-danger my_custom_orderPage_btns btn-sm"
              onClick={() => {
                this.submitVendorUploads("rejectOrder");
              }}
            >
              Reject
            </a>
          </>
        );
      }
    }
  }
  showOrderAcceptedByClient(IsOrderAcceptedbyClient, isAdmin, FinalAmount) {
    console.log(IsOrderAcceptedbyClient, isAdmin, FinalAmount, "56565656");
    if (isAdmin) {
      if (IsOrderAcceptedbyClient == true) {
        return (
          <>
            {" "}
            <div className="align-items-center gy-3 w-100">
              <a
                href="javascript:void(0);"
                className="btn btn-outline-success my_custom_orderPage_btns"
              >
                Accepted
              </a>
            </div>
          </>
        );
      } else {
        return (
          <>
            {" "}
            <a
              href="javascript:void(0);"
              className="btn btn-outline-warning my_custom_orderPage_btns"
            >
              Pending
            </a>
          </>
        );
      }
    } else {
      if (FinalAmount != null || FinalAmount != "") {
        if (
          IsOrderAcceptedbyClient == false ||
          IsOrderAcceptedbyClient == null
        ) {
          return (
            <>
              {console.log("correct case")}
              <a
                href="javascript:void(0);"
                className="btn btn-success my_custom_orderPage_btns mr-2 ml-2"
                onClick={() => this.submitVendorUploads("submitFinalAmount")}
              >
                Accept
              </a>
              <a
                href="javascript:void(0);"
                className="btn btn-danger my_custom_orderPage_btns"
              >
                Reject
              </a>
            </>
          );
        } else {
          return (
            <>
              {console.log("incorrect case")}{" "}
              <a
                href="javascript:void(0);"
                className="btn btn-outline-success my_custom_orderPage_btns"
              >
                Accepted
              </a>
            </>
          );
        }
      } else {
        return (
          <>
            {" "}
            <a
              href="javascript:void(0);"
              className="btn btn-outline-warning my_custom_orderPage_btns btn-sm"
            >
              Pending
            </a>
          </>
        );
      }
    }
  }
  toggleChat = () => {
    const { isChatOpen } = this.state;
    const OrderID =
      this.props.location.state != null &&
        this.props.location.state.OrderID != null
        ? this.props.location.state.OrderID
        : "";
    const ServiceID =
      this.props.location.state != null &&
        this.props.location.state.ServiceID != null
        ? this.props.location.state.ServiceID
        : "";
    const VendorID =
      this.props.location.state != null &&
        this.props.location.state.VendorID != null
        ? this.props.location.state.VendorID
        : "";
    this.setState((prevState) => ({
      isChatOpen: !prevState.isChatOpen,
    }));
    if (isChatOpen == true) {
      clearInterval(this.chatInterval);
    } else {
      this.getChatDetails(OrderID, ServiceID, VendorID);
      console.log("chatTrue");
    }
  };

  sendMessage = () => {
    const { chat, OrderID, ServiceID, VendorID } = this.state;
    if (chat.trim() === "") {
      toast.error("Kindly enter message", {
        position: "top-center",
        theme: "colored",
        hideProgressBar: true,
        autoClose: 3000,
      });
    } else {
      this.props
        .insert_chat_action(OrderID, VendorID, ServiceID, chat, 0)
        .then((data) => {
          console.log(data, "chat submitted");
          if (data.error !== 1) {
            this.setState({ chat: "" });
            // toast.success("Chat Submitted Successfully", {
            //   theme: "colored",
            //   position: "top-center",
            //   autoClose: 3000,
            //   hideProgressBar: true,
            // });
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  render() {
    const {
      isLoading,
      isAccordionExpanded, isChatLoading,
      thirdPartyDetails,
      isAdmin,
      showDetails,
      showAdditionalDetails,
      showPackageDetails,
      showAdditionalReq,
      Package,
      downloadUrl,
      FinalAmount,
      AdditionalAmount,
      IsOrderAcceptedbyVendor,
      IsOrderAcceptedbyClient,
      IsQuotationSubmitted,
      IsQuotationApproved,
      IsInvoiceSubmitted,
      IsPaymentReceived,
      quotationFileName,
      quotationFilePath,
      invoiceFileName,
      invoiceFilePath,
      receiptFileName,
      receiptFilePath,
      additionalInvoiceFileName,
      additionalInvoiceFilePath,
      additionalReceiptFileName,
      additionalReceiptFilePath,
      OrderAcceptedbyClientSignature,
      clientAcceptSignatureFlag,
      isSignatureSaved,
      OrderAcceptedbyClientContact,
      OrderAcceptedbyClientSignatureBy,
      IsFinalInvoiceSubmitted,
      //client Details
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      TANNumber,
      UINNumber,
      //chat
      isChatOpen,
      chat,
      chatDtl,
    } = this.state;
    const roleId = sessionStorage.getItem("roleId");
    const validChatDtl = chatDtl.filter((message) =>
      moment(message.datetime, moment.ISO_8601, true).isValid()
    );
    const sortedChatDtl = validChatDtl.sort((a, b) =>
      moment(a.datetime).diff(moment(b.datetime))
    );

    return (
      <>
        {isLoading ? <Loader></Loader> : false}
        <>
          <main id="main">
            <Header data={[18]} />
            <div className="thankYou_page" style={{ marginTop: 115 }}>
              <div className="thankYou_page_content">
                <div className="card product">
                  <div className="card-header">
                    <div className="order_no_and_date">
                      <div className="row">
                        <div className="col-md-6">
                          <h5>Third Party Order Details</h5>
                        </div>
                        <div className="col-md-6 text-right">
                          <h5>{thirdPartyDetails.Action}</h5>
                        </div>
                      </div>
                    </div>
                    <div className="search_accordion search_card">
                      <div className="panel-group" id="accordion">
                        <div className="panel panel-default">
                          <div
                            className="panel-heading accordion-toggle collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion"
                            data-target="#collapseOne"
                            aria-expanded={isAccordionExpanded}
                            onClick={() =>
                              this.setState({
                                isAccordionExpanded: !isAccordionExpanded,
                              })
                            }
                          >
                            <h4 className="panel-title">Organizer Details</h4>
                          </div>
                          <div
                            id="collapseOne"
                            className={`panel-collapse collapse pt-0 pb-0 ${isAccordionExpanded ? "show" : ""
                              }`}
                            aria-labelledby="headingOne"
                          >
                            <div className="panel-body">
                              <div className="card-body p-2">
                                <div className="company_info">
                                  <fieldset>
                                    <legend>
                                      Organizer's / Organization's Information
                                    </legend>
                                    <div class="outside_input_field ">
                                      <div class="row">
                                        <div class="col-md-4">
                                          <div class="form-group">
                                            <div class="position-relative">
                                              <input
                                                value={registrationNumber}
                                                type="text"
                                                class="outside"
                                                required
                                                disabled
                                                maxLength={20}
                                              />
                                              <span class="floating-label-outside">
                                                Registration Number{" "}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-4">
                                          <div class="form-group">
                                            <div class="position-relative">
                                              <input
                                                value={PANCardNo}
                                                type="text"
                                                class="outside"
                                                required
                                                disabled
                                                maxLength={10}
                                              />

                                              <span class="floating-label-outside">
                                                PAN Card No.{" "}
                                                <span class="mendatory_class">
                                                  *
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-4">
                                          <div class="form-group">
                                            <div class="position-relative">
                                              <input
                                                value={NameonPANCard}
                                                type="text"
                                                class="outside"
                                                required
                                                disabled
                                                maxLength={50}
                                              />

                                              <span class="floating-label-outside">
                                                Name on PAN Card{" "}
                                                <span class="mendatory_class">
                                                  *
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-4">
                                          <div class="form-group">
                                            <div class="position-relative">
                                              <input
                                                value={GSTNo}
                                                type="text"
                                                class="outside"
                                                required
                                                disabled
                                              />
                                              <span class="floating-label-outside">
                                                GST No.{" "}
                                              </span>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="col-md-4">
                                          <div class="form-group">
                                            <div class="position-relative">
                                              <input
                                                value={TANNumber}
                                                type="text"
                                                class="outside"
                                                required
                                                disabled
                                                maxLength={20}
                                              />
                                              <span class="floating-label-outside">
                                                TAN Number{" "}
                                              </span>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="col-md-4">
                                          <div class="form-group">
                                            <div class="position-relative">
                                              <input
                                                value={UINNumber}
                                                type="text"
                                                class="outside"
                                                required
                                                disabled
                                                maxLength={20}
                                              />
                                              <span class="floating-label-outside">
                                                UIN Number{" "}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </fieldset>
                                </div>
                                <div className="row">
                                  <div className="mx-3">
                                    <a
                                      href="javascript:void(0);"
                                      onClick={() =>
                                        this.setState({
                                          isAccordionExpanded:
                                            !isAccordionExpanded,
                                          isEditMode: true,
                                        })
                                      }
                                      className="btn back_btn"
                                    >
                                      Close
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <fieldset
                      className="p-0 pl-4 pt-2 pb-0"
                      style={{ paddingBottom: "0px", paddingTop: "0px" }}
                    >
                      <div class="outside_input_field">
                        <div class="row mt-2 mb-2">
                          <div class="col-md-3">
                            <div class="form-group">
                              <div class="position-relative w-100 d-flex">
                                <label className="mt-2" style={{ width: "40%" }}>Order No</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control"
                                  value={thirdPartyDetails.OrderNo}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <div class="position-relative w-100 d-flex">
                                <label className="mt-2" style={{ width: "40%" }}>
                                  Booking Date
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  disabled
                                  value={this.formatDate(
                                    thirdPartyDetails.BookingDate
                                  )}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <div class="position-relative w-100 d-flex">
                                <label className="mt-2" style={{ width: "40%" }}>Venue</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  disabled
                                  value={thirdPartyDetails.Venue}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row mt-2 mb-2">
                          <div class="col-md-3">
                            <div class="form-group">
                              <div class="position-relative w-100 d-flex">
                                <label className="mt-2" style={{ width: "40%" }}>Time</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  disabled
                                  value={thirdPartyDetails.BookingSlot}
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <div class="position-relative w-100 d-flex">
                                <label className="mt-2" style={{ width: "40%" }}>Service</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  disabled
                                  value={thirdPartyDetails.Service}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row mt-3 mb-2">
                          <div class="col-md-8">
                            <table
                              class="table table-bordered table-striped table-sm"
                              id="tbl"
                            >
                              <thead>
                                <tr>
                                  <th>SR NO.</th>
                                  <th>PACKAGE</th>
                                  <th>PACKAGE DETAILS</th>
                                  <th>Additional Requirement </th>
                                </tr>
                              </thead>
                              <tbody>
                                {thirdPartyDetails &&
                                  thirdPartyDetails.packageList &&
                                  thirdPartyDetails.packageList.length > 0 ? (
                                  thirdPartyDetails.packageList.map(
                                    (item, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.Package}</td>
                                        <td className="text-center">
                                          <i
                                            className="fa fa-table action_btn_table"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              this.togglePackageDetailsModal(
                                                item.PackageDetails,
                                                item.Package
                                              )
                                            }
                                          ></i>
                                        </td>
                                        <td className="text-center">
                                          <i
                                            className="fa fa-table action_btn_table"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              this.toggleAdditionalReqModal(
                                                item.AdditionalServiceRequirement,
                                                item.Package
                                              )
                                            }
                                          ></i>
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="4">No data available.</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <Modal
                        show={showDetails}
                        // onHide={this.togglePackageDetailsModal}
                        size="md"
                      >
                        <Modal.Header>
                          <Modal.Title>{Package}</Modal.Title>
                          <span
                            onClick={() => this.togglePackageDetailsModal()}
                            style={{
                              cursor: "pointer",
                              fontWeight: "800",
                            }}
                          >
                            X
                          </span>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="modal-body">
                            <div>
                              <pre
                                dangerouslySetInnerHTML={{
                                  __html: showPackageDetails,
                                }}
                              />
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => this.togglePackageDetailsModal()}
                          >
                            {" "}
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      <Modal
                        show={showAdditionalDetails}
                        // onHide={this.toggleAdditionalReqModal}
                        size="md"
                      >
                        <Modal.Header>
                          <Modal.Title>{Package}</Modal.Title>
                          <span
                            onClick={() => this.toggleAdditionalReqModal()}
                            style={{
                              cursor: "pointer",
                              fontWeight: "800",
                            }}
                          >
                            X
                          </span>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="modal-body">
                            <div>
                              <pre
                                dangerouslySetInnerHTML={{
                                  __html: showAdditionalReq,
                                }}
                              />
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => this.toggleAdditionalReqModal()}
                          >
                            {" "}
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </fieldset>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="card">
                          <div class="card-body pt-1">
                            <div className="row">
                              <div className="col-md-12 pb-1" style={{ borderBottom: '1px solid #ddd' }}>
                                <h6
                                  className="pt-2"
                                  style={{ color: "#35b3e6", float: "left" }}
                                >
                                  Manage Order
                                </h6>
                                <div
                                  className="chat-btn"
                                  style={{ float: "right" }}
                                >
                                  <Button
                                    variant="primary"
                                    style={{
                                      backgroundColor: "#35b3e6",
                                      marginLeft: "1rem",
                                    }}
                                    onClick={this.toggleChat}
                                  >
                                    {sortedChatDtl.length === 0
                                      ? "Start Conversation"
                                      : "View Conversation"}{" "}
                                    &nbsp;{" "}
                                    <i
                                      className={`fa ${isChatOpen
                                        ? "fa-chevron-left"
                                        : "fa-chevron-right"
                                        }`}
                                    ></i>
                                  </Button>
                                </div>
                              </div>
                            </div>
                            <div class="company_info row">
                              <div class="col-md-5" style={{ borderRight: '1px solid #ddd' }}>
                                <div className="row mt-2">
                                  <div class="col-md-3">
                                    <label>Order Approval</label>
                                  </div>
                                  <div class="col-md-6">
                                    {this.showOrderAcceptedByVendor(
                                      IsOrderAcceptedbyVendor,
                                      isAdmin
                                    )}
                                  </div>
                                </div>
                                {isAdmin ? (
                                  <div className="row mt-2">
                                    <div class="col-md-3">
                                      <label>Quotation</label>
                                    </div>
                                    {quotationFilePath ? (
                                      <div class="col-md-5 p-0">
                                        <span
                                          style={{
                                            borderRadius: "20px",
                                            padding: "5px 10px",
                                            display: "inline-block",
                                          }}
                                        >
                                          <a
                                            style={{
                                              cursor: "pointer",
                                              color: "red",
                                              textDecoration: "none",
                                            }}
                                            title="View Quotation"
                                            target="_blank"
                                            href={`${downloadUrl}${quotationFilePath}`}
                                          >
                                            {quotationFilePath.split("/").pop()}
                                            {""}
                                          </a>
                                        </span>
                                      </div>
                                    ) : (
                                      <div
                                        class="col-md-4"
                                        style={{
                                          background: "#f0f0f0",
                                          borderRadius: "20px",
                                          color: "black",
                                          padding: "5px 4px",
                                          textAlign: "center",
                                          display: "inline-block",
                                        }}
                                      >
                                        No Quotation Submitted
                                      </div>
                                    )}
                                    <div class="col-md-5"></div>
                                  </div>
                                ) : (
                                  <div className="gy-3 m-2">
                                    <div class="row mt-2">
                                      <div class="col-md-3">
                                        <label>Upload Quotation</label>
                                      </div>
                                      {quotationFilePath ? (
                                        <div class="col-md-6">
                                          <span
                                            style={{
                                              background: "#f0f0f0",
                                              borderRadius: "20px",
                                              padding: "5px 10px",
                                              display: "inline-block",
                                            }}
                                          >
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                              title="View Quotation"
                                              target="_blank"
                                              href={`${downloadUrl}${quotationFilePath}`}
                                            >
                                              {quotationFilePath
                                                .split("/")
                                                .pop()}
                                              {""}
                                            </a>
                                          </span>
                                        </div>
                                      ) : quotationFileName === "" ? (
                                        <div class=" col-md-3">
                                          <input
                                            type="file"
                                            name="files[]"
                                            multiple
                                            class="custom-file-input form-control"
                                            id="customFile"
                                            onChange={(e) => {
                                              if (
                                                IsOrderAcceptedbyVendor == true
                                              ) {
                                                this.onFilePick(
                                                  e,
                                                  e.target.files,
                                                  1
                                                );
                                              } else {
                                                return toast.error(
                                                  "Kindly Submit Order Approval",
                                                  {
                                                    position: "top-center",
                                                    theme: "colored",
                                                    hideProgressBar: true,
                                                    autoClose: "2000",
                                                  }
                                                );
                                              }
                                            }}
                                          />
                                          <label
                                            class="custom-file-label"
                                            for="customFile"
                                          >
                                            Upload Quotation{" "}
                                            <span className="upload_size">
                                              (PDF ONLY, Max 5MB)
                                            </span>
                                          </label>
                                        </div>
                                      ) : (
                                        <div class="col-md-6">
                                          <span
                                            style={{
                                              background: "#f0f0f0",
                                              borderRadius: "20px",
                                              padding: "5px 10px",
                                              display: "inline-block",
                                            }}
                                          >
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                              title="View Quotation"
                                              target="_blank"
                                              href={`${downloadUrl}${quotationFilePath}`}
                                            >
                                              {quotationFileName}
                                              {""}
                                            </a>
                                            <span
                                              onClick={() => this.removeFile(1)}
                                              style={{
                                                marginLeft: "5px",
                                                fontSize: "12px",
                                                color: "red",
                                                cursor: "pointer",
                                              }}
                                            >
                                              X
                                            </span>
                                          </span>
                                          {IsQuotationSubmitted == 1 ? (
                                            <a
                                              href="javascript:void(0);"
                                              className="btn btn-outline-warning my_custom_orderPage_btns btn-sm btn-sm"
                                            >
                                              Submitted
                                            </a>
                                          ) : (
                                            <a
                                              href="javascript:void(0);"
                                              className="btn btn-warning my_custom_orderPage_btns btn-sm btn-sm"
                                              onClick={() => {
                                                this.submitVendorUploads(
                                                  "quotationSubmit"
                                                );
                                              }}
                                            >
                                              Submit Quotation
                                            </a>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                                <div class="row mt-2">
                                  <div class="col-md-3">
                                    <label>Quotation Status</label>
                                  </div>
                                  <div className="col-6">
                                    <div class="form-group mb-0">
                                      {IsQuotationApproved == true ? (
                                        <a
                                          href="javascript:void(0);"
                                          className="btn btn-outline-success my_custom_orderPage_btns btn-sm btn-sm"
                                        >
                                          Accepted
                                        </a>
                                      ) : (
                                        <a
                                          href="javascript:void(0);"
                                          className="btn btn-outline-warning my_custom_orderPage_btns btn-sm btn-sm"
                                        >
                                          Pending
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div class="row mt-2">
                                  <div class="col-md-3">
                                    <label>
                                      Final Amount
                                    </label>
                                  </div>
                                  <div class="col-md-6">
                                    <input
                                      type="text"
                                      class="form-control"
                                      required
                                      value={FinalAmount?.toLocaleString(
                                        "en-IN"
                                      )}
                                      disabled={
                                        IsQuotationApproved == null ||
                                        invoiceFilePath != null ||
                                        isAdmin
                                      }
                                      maxLength={10}
                                      onChange={(e) =>
                                        this.setState({
                                          FinalAmount: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                {isAdmin ? (
                                  <div class="row mt-2">
                                    <div class="col-md-3">
                                      <label>Upload Invoice</label>
                                    </div>
                                    {invoiceFilePath ? (
                                      <div class="col-md-6">
                                        <span>
                                          <a
                                            style={{
                                              cursor: "pointer",
                                              color: "red",
                                              textDecoration: "none",
                                            }}
                                            title="View Invoice"
                                            target="_blank"
                                            href={`${downloadUrl}${invoiceFilePath}`}
                                          >
                                            {invoiceFilePath.split("/").pop()}
                                            {""}
                                          </a>
                                        </span>
                                      </div>
                                    ) : (
                                      <div
                                        class="col-md-4"
                                      >
                                        No Invoice Submitted
                                      </div>
                                    )}

                                    <div class="col-md-6"></div>
                                  </div>
                                ) : (
                                  <div className="align-items-center gy-3 m-2">
                                    <div class="row">
                                      <div class="col-md-10">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label>Upload Invoice</label>
                                          </div>
                                          {invoiceFilePath ? (
                                            <div class="col-md-7">
                                              <span
                                                style={{
                                                  background: "#f0f0f0",
                                                  borderRadius: "20px",
                                                  padding: "5px 10px",
                                                  display: "inline-block",
                                                }}
                                              >
                                                <a
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "red",
                                                    textDecoration: "none",
                                                  }}
                                                  title="View Quotation"
                                                  target="_blank"
                                                  href={`${downloadUrl}${invoiceFilePath}`}
                                                >
                                                  {invoiceFilePath
                                                    .split("/")
                                                    .pop()}
                                                  {""}
                                                </a>
                                              </span>
                                            </div>
                                          ) : invoiceFileName === "" ? (
                                            <div class="col-md-7">
                                              <input
                                                type="file"
                                                name="files[]"
                                                multiple
                                                class="custom-file-input form-control"
                                                id="customFile"
                                                onChange={(e) => {
                                                  if (
                                                    FinalAmount == null ||
                                                    FinalAmount == ""
                                                  ) {
                                                    return toast.error(
                                                      "Enter Final Amount",
                                                      {
                                                        position: "top-center",
                                                        theme: "colored",
                                                        hideProgressBar: true,
                                                        autoClose: "2000",
                                                      }
                                                    );
                                                  } else {
                                                    this.onFilePick(
                                                      e,
                                                      e.target.files,
                                                      2
                                                    );
                                                  }
                                                }}
                                              />
                                              <label
                                                class="custom-file-label"
                                                for="customFile"
                                              >
                                                Upload Invoice{" "}
                                                <span className="upload_size">
                                                  (PDF ONLY, Max 5MB)
                                                </span>
                                              </label>
                                            </div>
                                          ) : (
                                            <div class="col-md-6">
                                              <span
                                                style={{
                                                  background: "#f0f0f0",
                                                  borderRadius: "20px",
                                                  padding: "5px 10px",
                                                  display: "inline-block",
                                                }}
                                              >
                                                <a
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "red",
                                                    textDecoration: "none",
                                                  }}
                                                  title="View Invoice"
                                                  target="_blank"
                                                  href={`${downloadUrl}${invoiceFilePath}`}
                                                >
                                                  {invoiceFileName}
                                                  {""}
                                                </a>
                                                <span
                                                  onClick={() =>
                                                    this.removeFile(2)
                                                  }
                                                  style={{
                                                    marginLeft: "5px",
                                                    fontSize: "12px",
                                                    color: "red",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  X
                                                </span>
                                              </span>
                                              <a
                                                href="javascript:void(0);"
                                                className="btn btn-warning my_custom_orderPage_btns btn-sm btn-sm"
                                                onClick={() => {
                                                  this.submitVendorUploads(
                                                    "invoiceSubmit"
                                                  );
                                                }}
                                              >
                                                Submit Invoice
                                              </a>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {isAdmin ? (
                                  <div class="row mt-2">
                                    <div class="col-md-3">
                                      <label>Upload Receipt</label>
                                    </div>
                                    {receiptFilePath ? (
                                      <div class="col-md-6">
                                        <span>
                                          <a
                                            style={{
                                              cursor: "pointer",
                                              color: "red",
                                              textDecoration: "none",
                                            }}
                                            title="View Invoice"
                                            target="_blank"
                                            href={`${downloadUrl}${receiptFilePath}`}
                                          >
                                            {receiptFilePath.split("/").pop()}
                                            {""}
                                          </a>
                                        </span>
                                      </div>
                                    ) : (
                                      <div
                                        class="col-md-4"
                                        style={{
                                          background: "#f0f0f0",
                                          borderRadius: "20px",
                                          color: "black",
                                          padding: "5px 4px",
                                          textAlign: "center",
                                          display: "inline-block",
                                        }}
                                      >
                                        No Receipt Submitted
                                      </div>
                                    )}

                                    <div class="col-md-6"></div>
                                  </div>
                                ) : (
                                  <div className="align-items-center gy-3 m-2">
                                    <div class="row">
                                      <div class="col-md-10">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label>Upload Receipt</label>
                                          </div>
                                          {receiptFilePath ? (
                                            <div class="col-md-7">
                                              <span
                                                style={{

                                                  borderRadius: "20px",
                                                  padding: "5px 10px",
                                                  display: "inline-block",
                                                }}
                                              >
                                                <a
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "red",
                                                    textDecoration: "none",
                                                  }}
                                                  title="View Quotation"
                                                  target="_blank"
                                                  href={`${downloadUrl}${receiptFilePath}`}
                                                >
                                                  {receiptFilePath
                                                    .split("/")
                                                    .pop()}
                                                  {""}
                                                </a>
                                              </span>
                                            </div>
                                          ) : receiptFileName === "" ? (
                                            <div class="col-md-7">
                                              <input
                                                type="file"
                                                name="files[]"
                                                multiple
                                                class="custom-file-input form-control"
                                                id="customFile"
                                                onChange={(e) => {
                                                  if (
                                                    IsInvoiceSubmitted == true
                                                  ) {
                                                    this.onFilePick(
                                                      e,
                                                      e.target.files,
                                                      3
                                                    );
                                                  } else {
                                                    return toast.error(
                                                      "Kindly Upload Inovice",
                                                      {
                                                        position: "top-center",
                                                        theme: "colored",
                                                        hideProgressBar: true,
                                                        autoClose: "2000",
                                                      }
                                                    );
                                                  }
                                                }}
                                              />
                                              <label
                                                class="custom-file-label"
                                                for="customFile"
                                              >
                                                Upload Receipt{" "}
                                                <span className="upload_size">
                                                  (PDF ONLY, Max 5MB)
                                                </span>
                                              </label>
                                            </div>
                                          ) : (
                                            <div class="col-md-6">
                                              <span
                                                style={{
                                                  background: "#f0f0f0",
                                                  borderRadius: "20px",
                                                  padding: "5px 10px",
                                                  display: "inline-block",
                                                }}
                                              >
                                                <a
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "red",
                                                    textDecoration: "none",
                                                  }}
                                                  title="View Invoice"
                                                  target="_blank"
                                                  href={`${downloadUrl}${receiptFilePath}`}
                                                >
                                                  {receiptFileName}
                                                  {""}
                                                </a>
                                                <span
                                                  onClick={() =>
                                                    this.removeFile(3)
                                                  }
                                                  style={{
                                                    marginLeft: "5px",
                                                    fontSize: "12px",
                                                    color: "red",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  X
                                                </span>
                                              </span>
                                              <a
                                                href="javascript:void(0);"
                                                className="btn btn-warning my_custom_orderPage_btns btn-sm btn-sm"
                                                onClick={() => {
                                                  this.submitVendorUploads(
                                                    "receiptSubmit"
                                                  );
                                                }}
                                              >
                                                Submit Receipt
                                              </a>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>

                              <div class="col-md-5 pl-4">
                                <div class="row mt-2">
                                  <div class="col-md-8">
                                    <div class="form-group">
                                      <div class="align-items-center position-relative w-100 d-flex">
                                        <label
                                          style={{
                                            width: "75%",
                                            marginTop: "8px",
                                          }}
                                        >
                                          Additional Amount
                                        </label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          disabled={
                                            IsPaymentReceived == null ||
                                            IsOrderAcceptedbyClient != null ||
                                            isAdmin
                                          }
                                          required
                                          value={AdditionalAmount?.toLocaleString(
                                            "en-IN"
                                          )}
                                          maxLength={10}
                                          onChange={(e) =>
                                            this.setState({
                                              AdditionalAmount: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {AdditionalAmount != null ? (
                                  <div class="row mb-2 align-items-center">
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="position-relative w-100 d-flex">
                                          <h6 className="text-info">
                                            Confirmation from Client:
                                          </h6>
                                        </div>
                                        <div class="align-items-center position-relative w-100 d-flex mb-2">
                                          <label
                                            style={{
                                              width: "50%",
                                              marginTop: "8px",
                                            }}
                                          >
                                            Client Contact Details
                                          </label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            disabled={
                                              IsPaymentReceived == null ||
                                              IsOrderAcceptedbyClient != null ||
                                              isAdmin
                                            }
                                            required
                                            value={OrderAcceptedbyClientContact}
                                            maxLength={10}
                                            onChange={(e) =>
                                              this.setState({
                                                OrderAcceptedbyClientContact:
                                                  e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                        {OrderAcceptedbyClientContact == "" ||
                                          OrderAcceptedbyClientContact == null ? (
                                          <></>
                                        ) : (
                                          <>
                                            <div
                                              class="client_signature_box"
                                              style={{
                                                border: "1px solid #c9c8c8",
                                                width: 400,
                                                borderRadius: '5px'
                                              }}
                                            >
                                              {isSignatureSaved ? (
                                                <>
                                                  {console.log(
                                                    isSignatureSaved,
                                                    OrderAcceptedbyClientSignature,
                                                    "OrderAcceptedbyClientSignature"
                                                  )}
                                                  <img
                                                    src={
                                                      OrderAcceptedbyClientSignature
                                                    }
                                                    style={{
                                                      width: 400,
                                                      height: 150,
                                                    }}
                                                    alt="Saved Signature"
                                                  />
                                                </>
                                              ) : (
                                                <div>
                                                  <SignatureCanvas
                                                    ref={this.signatureRef}
                                                    penColor="rgb(126 123 123)"
                                                    canvasProps={{
                                                      width: 400,
                                                      height: 150,
                                                      className:
                                                        "signature-canvas",
                                                    }}
                                                  />
                                                </div>
                                              )}
                                            </div>
                                            <div style={{ marginTop: "10px" }}>
                                              {clientAcceptSignatureFlag ? (
                                                <>
                                                  {OrderAcceptedbyClientSignatureBy ==
                                                    null ? (
                                                    <>
                                                      <button
                                                        onClick={
                                                          this
                                                            .clearSaveSignatureImg
                                                        }
                                                        class="btn btn-secondary m-1"
                                                      >
                                                        Clear
                                                      </button>
                                                      <button class="btn btn-outline-success m-1">
                                                        Saved
                                                      </button>
                                                    </>
                                                  ) : (
                                                    <></>
                                                  )}
                                                  {this.showOrderAcceptedByClient(
                                                    IsOrderAcceptedbyClient,
                                                    isAdmin,
                                                    FinalAmount
                                                  )}
                                                </>
                                              ) : (
                                                <button
                                                  onClick={this.clearSignature}
                                                  class="btn btn-secondary m-1"
                                                >
                                                  Clear
                                                </button>
                                              )}
                                              {clientAcceptSignatureFlag ? (
                                                <></>
                                              ) : (
                                                <>
                                                  <button
                                                    onClick={this.saveSignature}
                                                    class="btn btn-success mr-2"
                                                  >
                                                    Save
                                                  </button>
                                                </>
                                              )}
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div class="row mt-2 mb-2 align-items-center">
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="position-relative w-100 d-flex align-items-center">
                                          <label>
                                            Confirmation from Client
                                          </label>
                                          <div
                                            className="w-100"
                                            style={{
                                              marginLeft: "-200px",
                                              padding: "4px",
                                              background: "#E9ECEF",
                                              borderRadius: "4px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Additional Amount Not submitted by
                                            vendor
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {isAdmin ? (
                                  <div class="row mt-2">
                                    <div class="col-md-3">
                                      <label>Upload Invoice</label>
                                    </div>
                                    {additionalInvoiceFilePath ? (
                                      <div class="col-md-8">
                                        <span
                                          style={{
                                            borderRadius: "20px",
                                            padding: "5px 10px",
                                            display: "inline-block",
                                          }}
                                        >
                                          <a
                                            style={{
                                              cursor: "pointer",
                                              color: "red",
                                              textDecoration: "none",
                                            }}
                                            title="View Invoice"
                                            target="_blank"
                                            href={`${downloadUrl}${additionalInvoiceFilePath}`}
                                          >
                                            {additionalInvoiceFilePath
                                              .split("/")
                                              .pop()}
                                            {""}
                                          </a>
                                        </span>
                                      </div>
                                    ) : (
                                      <div
                                        class="col-md-4"
                                        style={{
                                          background: "#f0f0f0",
                                          borderRadius: "20px",
                                          color: "black",
                                          padding: "5px 4px",
                                          textAlign: "center",
                                          display: "inline-block",
                                        }}
                                      >
                                        No Invoice Submitted
                                      </div>
                                    )}

                                    <div class="col-md-6"></div>
                                  </div>
                                ) : (
                                  <div class="row mt-2">
                                    <div class="col-md-3">
                                      <label class="mt-1">Upload Invoice</label>
                                    </div>
                                    {additionalInvoiceFilePath ? (
                                      <div class="col-md-6">
                                        <span
                                          style={{
                                            background: "#f0f0f0",
                                            borderRadius: "20px",
                                            padding: "5px 10px",
                                            display: "inline-block",
                                          }}
                                        >
                                          <a
                                            style={{
                                              cursor: "pointer",
                                              color: "red",
                                              textDecoration: "none",
                                            }}
                                            title="View Quotation"
                                            target="_blank"
                                            href={`${downloadUrl}${additionalInvoiceFilePath}`}
                                          >
                                            {additionalInvoiceFilePath
                                              .split("/")
                                              .pop()}
                                            {""}
                                          </a>
                                        </span>
                                      </div>
                                    ) : additionalInvoiceFileName === "" ? (
                                      <div class="col-md-6">
                                        <input
                                          type="file"
                                          name="files[]"
                                          multiple
                                          class="custom-file-input form-control"
                                          id="customFile"
                                          onChange={(e) => {
                                            if (
                                              IsOrderAcceptedbyClient == true
                                            ) {
                                              this.onFilePick(
                                                e,
                                                e.target.files,
                                                4
                                              );
                                            } else {
                                              return toast.error(
                                                "Kindly Submit Additional Amount Confirmation",
                                                {
                                                  position: "top-center",
                                                  theme: "colored",
                                                  hideProgressBar: true,
                                                  autoClose: "2000",
                                                }
                                              );
                                            }
                                          }}
                                        />
                                        <label
                                          class="custom-file-label mt-1"
                                          for="customFile"
                                        >
                                          Upload Invoice{" "}
                                          <span className="upload_size">
                                            (PDF ONLY, Max 5MB)
                                          </span>
                                        </label>
                                      </div>
                                    ) : (
                                      <div class="col-md-6">
                                        <span
                                          style={{
                                            background: "#f0f0f0",
                                            borderRadius: "20px",
                                            padding: "5px 10px",
                                            display: "inline-block",
                                          }}
                                        >
                                          <a
                                            style={{
                                              cursor: "pointer",
                                              color: "red",
                                              textDecoration: "none",
                                            }}
                                            title="View Invoice"
                                            target="_blank"
                                            href={`${downloadUrl}${additionalInvoiceFilePath}`}
                                          >
                                            {additionalInvoiceFileName}
                                            {""}
                                          </a>
                                          <span
                                            onClick={() => this.removeFile(4)}
                                            style={{
                                              marginLeft: "5px",
                                              fontSize: "12px",
                                              color: "red",
                                              cursor: "pointer",
                                            }}
                                          >
                                            X
                                          </span>
                                        </span>
                                        <a
                                          href="javascript:void(0);"
                                          className="btn btn-warning my_custom_orderPage_btns btn-sm btn-sm"
                                          onClick={() => {
                                            this.submitVendorUploads(
                                              "additionalInvoiceSubmit"
                                            );
                                          }}
                                        >
                                          Submit Invoice
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                )}
                                {isAdmin ? (
                                  <div class="row mt-1">
                                    <div class="col-md-3">
                                      <label class="mt-1">Upload Receipt</label>
                                    </div>
                                    {additionalReceiptFilePath ? (
                                      <div class="col-md-8">
                                        <span
                                          style={{

                                            borderRadius: "20px",
                                            padding: "5px 10px",
                                            display: "inline-block",
                                          }}
                                        >
                                          <a
                                            style={{
                                              cursor: "pointer",
                                              color: "red",
                                              textDecoration: "none",
                                            }}
                                            title="View Invoice"
                                            target="_blank"
                                            href={`${downloadUrl}${additionalReceiptFilePath}`}
                                          >
                                            {additionalReceiptFilePath
                                              .split("/")
                                              .pop()}
                                            {""}
                                          </a>
                                        </span>
                                      </div>
                                    ) : (
                                      <div
                                        class="col-md-4"
                                        style={{
                                          background: "#f0f0f0",
                                          borderRadius: "20px",
                                          color: "black",
                                          padding: "5px 4px",
                                          textAlign: "center",
                                          display: "inline-block",
                                        }}
                                      >
                                        No Receipt Submitted
                                      </div>
                                    )}

                                    <div class="col-md-6"></div>
                                  </div>
                                ) : (
                                  <div className="align-items-center gy-3 mt-2">
                                    <div class="row">
                                      <div class="col-md-3">
                                        <label>Upload Receipt</label>
                                      </div>
                                      {additionalReceiptFilePath ? (
                                        <div class="col-md-6">
                                          <span
                                            style={{

                                              borderRadius: "20px",
                                              padding: "5px 10px",
                                              display: "inline-block",
                                            }}
                                          >
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                              title="View Quotation"
                                              target="_blank"
                                              href={`${downloadUrl}${additionalReceiptFilePath}`}
                                            >
                                              {additionalReceiptFilePath
                                                .split("/")
                                                .pop()}
                                              {""}
                                            </a>
                                          </span>
                                        </div>
                                      ) : additionalReceiptFileName === "" ? (
                                        <div class="col-md-6">
                                          <input
                                            type="file"
                                            name="files[]"
                                            multiple
                                            class="custom-file-input form-control"
                                            id="customFile"
                                            onChange={(e) => {
                                              if (
                                                IsFinalInvoiceSubmitted == true
                                              ) {
                                                this.onFilePick(
                                                  e,
                                                  e.target.files,
                                                  5
                                                );
                                              } else {
                                                return toast.error(
                                                  "Kindly Upload Additional Amount Invoice",
                                                  {
                                                    position: "top-center",
                                                    theme: "colored",
                                                    hideProgressBar: true,
                                                    autoClose: "2000",
                                                  }
                                                );
                                              }
                                            }}
                                          />
                                          <label
                                            class="custom-file-label"
                                            for="customFile"
                                          >
                                            Upload Receipt{" "}
                                            <span className="upload_size">
                                              (PDF ONLY, Max 5MB)
                                            </span>
                                          </label>
                                        </div>
                                      ) : (
                                        <div class="col-md-6">
                                          <span
                                            style={{
                                              background: "#f0f0f0",
                                              borderRadius: "20px",
                                              padding: "5px 10px",
                                              display: "inline-block",
                                            }}
                                          >
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                              title="View Invoice"
                                              target="_blank"
                                              href={`${downloadUrl}${additionalReceiptFilePath}`}
                                            >
                                              {additionalReceiptFileName}
                                              {""}
                                            </a>
                                            <span
                                              onClick={() => this.removeFile(5)}
                                              style={{
                                                marginLeft: "5px",
                                                fontSize: "12px",
                                                color: "red",
                                                cursor: "pointer",
                                              }}
                                            >
                                              X
                                            </span>
                                          </span>
                                          <a
                                            href="javascript:void(0);"
                                            className="btn btn-warning my_custom_orderPage_btns btn-sm btn-sm"
                                            onClick={() => {
                                              this.submitVendorUploads(
                                                "additionalReceiptSubmit"
                                              );
                                            }}
                                          >
                                            Submit Receipt
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <div className={`chat-container ${isChatOpen ? "chat-open" : ""}`}>
            <div className="chat-box p-2">
              <div className="chat-header">
                <div class="row">
                  <div class="col-md-9">
                    <h6 class="p-2">
                      {thirdPartyDetails.VendorCompany} -{" "}
                      {thirdPartyDetails.ServiceName}
                    </h6>
                  </div>
                  <div class="col-md-3">
                    <Button variant="light" onClick={this.toggleChat}>
                      X
                    </Button>
                  </div>
                </div>
                <hr />
              </div>
              <div className="chat-messages">
                {sortedChatDtl.length === 0 ? (<>
                  {isAdmin ?
                    (
                      <div className="message incoming">{isChatLoading ? "Loading..." : "No conversation Started"}</div>
                    )
                    : (
                      <div className="message incoming">{isChatLoading ? "Loading..." : "Start conversation"}</div>
                    )}</>
                ) : (
                  sortedChatDtl.map((message, index) => {
                    const isOutgoing =
                      (roleId === "3" && message.isClient) ||
                      (roleId === "13" && !message.isClient);
                    const showDateSeparator =
                      index === 0 ||
                      moment(message.datetime).format("YYYY-MM-DD") !==
                      moment(sortedChatDtl[index - 1].datetime).format(
                        "YYYY-MM-DD"
                      );

                    return (
                      <>
                        {showDateSeparator && (
                          <div className="date-separator">
                            {moment(message.datetime).format("MMM DD, YYYY")}
                          </div>
                        )}
                        <div
                          key={index}
                          className={`message ${isOutgoing ? "outgoing" : "incoming"
                            }`}
                        >
                          <div className="message-content">{message.chat}</div>
                          <span className="time">
                            {moment(message.datetime).format("h:mm A")}
                          </span>
                        </div>
                      </>
                    );
                  })
                )}
              </div>
              {isAdmin ? <></> : (
                <div className="chat-input">
                  <div className="row p-2">
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Type your message..."
                        value={chat}
                        onChange={(e) => this.setState({ chat: e.target.value })}
                      />
                    </div>
                    <div className="col-md-3">
                      <Button variant="primary" onClick={this.sendMessage}>
                        Send
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <style type="text/css">{floatingLabelCSSOrders}</style>
          <ToastContainer />
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    thirdParty_detail_action,
    insertUpdate_thirdParty_vendorOrderDtl_action,
    thirdParty_VendorOrder_detail_action,
    client_detail_action,
    chat_detail_action,
    insert_chat_action,
  })(ThirdPartyOrderAU)
);
